import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0); // First FAQ open by default

  const faqData = [
    {
      question: "What is GrowthSchool?",
      answer: "GrowthSchool is a cutting-edge platform designed to help businesses and professionals scale faster through top-tier education. We offer online learning programs that cater to various industries, allowing companies to upskill their teams with practical knowledge from industry experts."
    },
    {
      question: "How can GrowthSchool help my business grow?",
      answer: "GrowthSchool offers tailored learning experiences that focus on critical skills like sales, marketing, leadership, and growth strategies. By upskilling your team with real-world knowledge and tools, you can accelerate your business' growth, enhance productivity, and improve overall performance."
    },
    {
      question: "Can GrowthSchool customize training for my organization?",
      answer: "Yes, we offer customizable corporate training programs that can be designed to meet the specific needs of your business. Whether you're looking to enhance team collaboration, refine leadership skills, or drive innovation, we can create a solution tailored to your goals."
    },
    {
      question: "Who are the instructors at GrowthSchool?",
      answer: "GrowthSchool partners with top industry leaders and experts who have extensive experience in their respective fields. These instructors bring practical, real-world insights that your team can immediately apply in their work."
    },
    {
      question: "How is GrowthSchool different from other learning platforms?",
      answer: "Unlike other platforms that offer generic courses, GrowthSchool focuses on interactive learning, practical application, and expert-led sessions. We prioritize real-time problem solving, live mentoring, and a curriculum designed to meet the specific needs of businesses looking to scale quickly."
    },
    {
      question: "What types of businesses can benefit from GrowthSchool?",
      answer: "GrowthSchool is perfect for businesses across various industries, including tech startups, marketing agencies, sales teams, and enterprise-level companies. If your goal is to rapidly upskill your workforce and scale effectively, GrowthSchool has the resources you need."
    },
    {
      question: "How do I enroll my team or company in GrowthSchool programs?",
      answer: "Enrollment is easy! Simply reach out to us via filling your contact details, and one of our representatives will assist you in choosing the right program for your team."
    },
    {
      question: "What is the cost of GrowthSchool programs for businesses?",
      answer: "Pricing varies depending on the size of your team, the program selected, and any customization needs. We offer competitive rates and are happy to discuss bulk pricing options."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="w-full py-16" style={{ backgroundColor: 'rgb(255, 250, 241)' }}>
      <div className="w-[90%] md:w-[80%] mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
          
          {/* Left Side - Header */}
          <div className="lg:w-2/5">
            <p className="text-sm uppercase font-medium tracking-wide text-gray-600 mb-4">
              STILL UNSURE?
            </p>
            <h2 className="text-2xl md:text-[36px] font-medium leading-tight text-gray-900">
              Frequently<br />
              Asked Questions
            </h2>
          </div>

          {/* Right Side - FAQ Items */}
          <div className="lg:w-3/5">
            <div className="space-y-4">
              {faqData.map((faq, index) => (
                <div
                  key={index}
                  className="border border-gray-200 rounded-2xl bg-white transition-all duration-200"
                >
                  <button
                    onClick={() => toggleFAQ(index)}
                    className="w-full px-6 py-6 text-left flex justify-between items-center hover:bg-gray-50 rounded-2xl transition-colors"
                  >
                    <span className="text-gray-900 font-medium text-lg pr-4">
                      {faq.question}
                    </span>
                    <svg
                      className={`w-6 h-6 text-gray-500 transform transition-transform duration-200 flex-shrink-0 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                  
                  {openIndex === index && (
                    <div className="px-6 pb-6">
                      <div className="border-t border-gray-100 pt-4">
                        <p className="text-gray-600 leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;